<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">إضافة طلب إدارة أملاك</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/managementReqs">إدارة الاملاك</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">إضافة طلب</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <div class="card card-secondary card-outline mb-4 mt-4">
              <div class="card-header"><div class="card-title">إضافة طلب إدارة أملاك</div></div>
              <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
              <successAlert v-if="hasSucess" :message="message" />

              <form @submit.prevent="submitData()">
                <div class="card-body">
                  <!-- client lookup -->
                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">جوال العميل: <span class="req">*</span></label>
                      <input type="text" class="form-control" placeholder="جوال العميل المسجل" @keyup="getClientData()" v-model="userMobile">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <loader v-if="userLoader" />
                      <div v-if="userName">
                        <label class="form-label">اسم العميل:</label>
                        <div>{{ userName }}</div>
                      </div>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">اسم مقدم الطلب: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="name">
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">رقم جوال التواصل: <span class="req">*</span></label>
                      <input type="text" class="form-control" v-model="mobile">
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">المنطقة: <span class="req">*</span></label>
                      <select class="form-control" v-model="regionId" @change="getCitiesList()">
                        <option :value="null">اختر المنطقة</option>
                        <option v-for="r in regionsList" :value="r.id" :key="r.id">{{ r.name }}</option>
                      </select>
                    </div>
                    <div class="col-12 col-sm-6 mb-3">
                      <label class="form-label">المدينة: <span class="req">*</span></label>
                      <select class="form-control" v-model="cityId">
                        <option :value="null">اختر المدينة</option>
                        <option v-for="c in citiesList" :value="c.id" :key="c.id">{{ c.name }}</option>
                      </select>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 mb-3">
                      <label class="form-label">تفاصيل الطلب:</label>
                      <textarea class="form-control" rows="3" v-model="description" placeholder="أدخل تفاصيل الطلب..."></textarea>
                    </div>
                  </div>
                </div>
                <!--begin::Footer-->
                <div class="card-footer">
                  <div class="row">
                    <div class="col text-end">
                      <button v-if="!formLoader" type="submit" class="btn btn-success">إضافة</button>
                      <loader v-if="formLoader" />
                    </div>
                  </div>
                </div>
                <!--end::Footer-->
              </form>
            </div>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'ManagementReqsCreate',
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,

      userMobile: null,
      userId: null,
      userName: null,
      userLoader: false,

      name: null,
      mobile: null,
      regionId: null,
      cityId: null,
      description: null,

      regionsList: [],
      citiesList: [],
    }
  },
  methods: {
    getClientData(){
      if(this.userMobile && this.userMobile.length >= 10){
        this.hasError = false;
        this.hasSucess = false;
        this.userLoader = true;
        this.userId = null;
        this.userName = null;
        this.$http.post('/api/admin/properties/getUser', {
          mobile: this.userMobile.trim(),
        }).then(({data}) => {
          this.userId = data.user.id;
          this.userName = data.user.name;
          if(!this.name)
            this.name = data.user.name;
          if(!this.mobile)
            this.mobile = data.user.mobile;
          this.userLoader = false;
        }).catch(err => {
          [this.message, this.errorNumber] = this.$globalError(err, true);
          this.hasError = true;
          this.userLoader = false;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        });
      }
    },
    getRegionsList(){
      this.$http.get('/api/admin/regions/list').then(({data}) => {
        this.regionsList = (data.regions ?? []).filter(r => r.isActive);
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    getCitiesList(){
      this.citiesList = [];
      this.cityId = null;
      if(!this.regionId)
        return;
      this.$http.get(`/api/admin/cities/list?regionId=${this.regionId}&all=1`).then(({data}) => {
        this.citiesList = data.cities;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
    submitData(){
      this.hasError = false;
      this.hasSucess = false;

      if(!this.userId){
        this.message = 'يجب تحديد العميل عن طريق رقم الجوال أولاً';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }
      if(!this.name || !this.mobile || !this.regionId || !this.cityId){
        this.message = 'يرجى تعبئة جميع الحقول المطلوبة';
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        return;
      }

      this.formLoader = true;
      this.$http.post('/api/admin/managementReq/create', {
        userId: this.userId,
        name: this.name,
        mobile: this.mobile,
        regionId: this.regionId,
        cityId: this.cityId,
        description: this.description,
      }).then(({data}) => {
        toast('تم إضافة الطلب بنجاح', 'success');
        this.$router.push(`/managementReqs/update/${data.row.id}`).catch(() => {});
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
  },
  created(){
    this.getRegionsList();
  }
}
</script>